// eslint doesn't like using interpolation to create white space
/* eslint-disable quotes */

import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import PropTypes from 'prop-types';
import { CrqListFilters } from 'AppSrc/core/components/crqs-screen/crq-list-filters';
import { CrqListTable } from 'AppSrc/core/components/crqs-screen/crq-list-table';
import { getCrqList } from 'AppSrc/core/crq/crq-queries';
import 'AppSrc/core/style/components/app-layout/page-content.css';
import 'AppSrc/core/style/components/crqs-screen/crqs-screen.css';
import 'AppSrc/core/style/components/search-crqs-screen/search-crqs-screen.css';
import { BackAndRefresh } from '../utility/back-refresh';


const MIN_CRQ_ID_CHARS = 1;

const getResultsMessage = ({
  hasResults,
  validSearch,
  searchQuery,
  numResults,
  fetching,
}) => {

  const StrongSearchQuery = () => (
    <>
      &lsquo;
      <strong>{searchQuery}</strong>
      &rsquo;
    </>
  );

  if (!validSearch) {
    return (
      <p>
        {`Invalid search `}
        <StrongSearchQuery />
      </p>
    );
  }

  if (fetching) {
    return (
      <p>
        {`Searching for `}
        <StrongSearchQuery />
      </p>
    );
  }

  if (hasResults) {
    return (
      <p>
        {`Your search results for `}
        <StrongSearchQuery />
        {` (${numResults} found)`}
      </p>
    );
  }

  return (
    <p>
      {`No search results for `}
      <StrongSearchQuery />
      {` please try again (0 found)`}
    </p>
  );
};


getResultsMessage.propTypes = {
  hasResults: PropTypes.bool,
  validSearch: PropTypes.bool,
  searchQuery: PropTypes.string,
  numResults: PropTypes.number,
  fetching: PropTypes.bool,
};


const SearchCrqsScreenDisplay = ({ searchQuery }) => {
  const [crqList, setCrqList] = useState(null);
  const [fetching, setFetching] = useState(false);
  const [validSearch, setValidSearch] = useState(null);
  const [filters, setFilters] = useState({});
  // on mount, fetch the crqs
  useEffect(
    () => {
      if (searchQuery && (searchQuery.length < MIN_CRQ_ID_CHARS)) {
        setValidSearch(false);
        return;
      }
      setValidSearch(true);
      setFetching(true);
      const params = { crq_id: searchQuery };
      getCrqList(params).then((results) => {
        // DISPATCH HERE FREYJA
        setFetching(false);
        setCrqList(results);
      });
    },
    [searchQuery, setFetching, setCrqList],
  );

  const numResults = crqList ? crqList.length : 0;
  const hasResults = numResults > 0;
  window.sessionStorage.clear();
  const resultMessage = getResultsMessage({
    hasResults,
    validSearch,
    searchQuery,
    numResults,
    fetching,
  });

  const isDuplicate = true;

  return (
    <div className="page-content-container crq-screen-container search-crqs-screen-container">
      <div className="page-top">
        <h1 className="page-title">
          Search Results
        </h1>
        <BackAndRefresh />
      </div>
      <div className="page-content">
        {hasResults ? (
          <>
            <CrqListFilters
              currentFilters={filters}
              setFilters={setFilters}
              title={resultMessage}
              showStatuses
              listIsSearch
            />
            <CrqListTable
              fetching={fetching}
              crqList={crqList}
              filters={filters}
              noResultsMessage="No search results with current filters"
              isDuplicate={isDuplicate}
            />
          </>
        ) : (
          <div className="page-content-inner">
            <div className="no-search-results">{resultMessage}</div>
          </div>
        )}
      </div>
    </div>
  );
};

SearchCrqsScreenDisplay.propTypes = {
  searchQuery: PropTypes.string,
};

const SearchCrqsScreen = () => {
  const { query } = useParams();
  return (
    <SearchCrqsScreenDisplay
      searchQuery={query}
      key={query} // component should re
    />
  );
};

export {
  SearchCrqsScreen,
  MIN_CRQ_ID_CHARS,
};
